setTimeout(()=>{
    $('.statusBottom li:last-child .status_wrap').before('<div class="bar-area"><div class="bar-wrap"><div class="bar bar1"></div><div class="bar bar2"></div><div class="bar bar3"></div><div class="bar bar4"></div><div class="bar bar5"><div class="bar_arrow"></div></div></div></div>');
},500)

$(window).on('scroll', function () {
  const $gnb = $('.gnb');
  const $ourStatus = $('.ourStatus');

  if (!$gnb.length || !$ourStatus.length) return;

  const gnbBottom = $gnb.offset().top + $gnb.outerHeight();
  const ourStatusTop = $ourStatus.offset().top;

  if (ourStatusTop <= gnbBottom) {
    $('.bar-area').addClass('is-active')
  }else{
    $('.bar-area').removeClass('is-active')
  }
});
